import type { WorkspaceAuthResult } from "./types";

const WORKSPACE_AUTH_EVENT = "workspace-auth-result";

function isTauriRuntime(): boolean {
  return "__TAURI__" in window || "__TAURI_INTERNALS__" in window;
}

async function publishResult(result: WorkspaceAuthResult): Promise<void> {
  if (isTauriRuntime()) {
    const { emitTo } = await import("@tauri-apps/api/event");
    await emitTo("main", WORKSPACE_AUTH_EVENT, result);
    return;
  }
  localStorage.setItem("workspace_auth_result", JSON.stringify(result));
}

async function closeCallbackWindow(): Promise<void> {
  if (isTauriRuntime()) {
    const { getCurrentWebviewWindow } = await import(
      "@tauri-apps/api/webviewWindow"
    );
    await getCurrentWebviewWindow().close();
    return;
  }
  window.close();
}

export async function publishResultAndClose(
  result: WorkspaceAuthResult,
): Promise<void> {
  // @tested-by: tst_fe_workspace_oauth_001, tst_fe_workspace_oauth_004
  // @invariant: every terminal OAuth result closes the dedicated callback window.
  await publishResult(result);
  await closeCallbackWindow();
}
